import styled from 'styled-components';
import { mediaQuery, CatalogImage } from 'components';

type ProductPriceStrikeThroughProps = {
  strikethrough: boolean;
  bold?: boolean;
};
export const ProductBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  img {
    ${mediaQuery.medium`
      aspect-ratio: 1 / 1;
      min-width: 315px;
    `}
    max-width: 100%;
  }

  .hover-image,
  .hover-video {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: 0.4s ease opacity;
    overflow: hidden;
    width: 100%;
  }

  .hover-image:hover,
  .hover-video:hover {
    opacity: 1;
    width: 100%;
  }

  .hover-video {
    height: 315px;
  }

  .zoom-image-container {
    display: block;
    overflow: hidden;
  }

  .zoom-image {
    transform: scale(1.1);
  }

  .price-link {
    cursor: pointer;
  }
`;

export const ProductBadge = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  padding: 4.5px 8px;
  border-radius: 3px;
  background-color: white;
  z-index: 1;

  > div {
    padding: 0;
  }

  span {
    display: block;
    font-size: 12px;
    letter-spacing: 1.5px;
    padding: 0;

    ${mediaQuery.tiny`
      font-size: 10px;
    `};

    ${mediaQuery.medium`
      font-size: 12px;
    `};
  }
`;

export const ProductDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 5px 0 25px 0;

  ${mediaQuery.medium`
    align-items: flex-start;
  `};

  a {
    width: 100%;
  }

  /* Product Price */
  p {
    margin: 2px 0;
    text-align: center;
    font-size: 16px;
    font-weight: 200;
    width: 100%;

    ${mediaQuery.medium`
      text-align: left;
    `};
  }

  /* Product Name */
  a p:first-of-type {
    font-weight: normal;
  }
`;

export const FixedSizeCatalogImage = styled(CatalogImage)`
  ${mediaQuery.medium`
    min-width: 100%;
    min-height: 100%;
    border-radius: 1px;
  `};
`;

export const ProductPrice = styled.span<ProductPriceStrikeThroughProps>`
  display: inline;
  font-weight: ${(props) => (props.bold ? 'bold' : '400')};
  color: ${(props) => (props.strikethrough ? '#757575' : '#000000')};
  text-decoration: ${(props) => (props.strikethrough ? 'line-through' : 'none')};
`;

export const ProductCalloutUl = styled.ul`
  ${mediaQuery.large`
    margin: 18px 0 0 90px;
    width: 100%;
    color: #000;
    font-family: 'Lato', 'helvetica neue', 'helvetica', 'arial', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.25px;
    display: contents;
  `}

  display: none;
`;

export const ProductCalloutLi = styled.li`
  margin-bottom: 5px;
  margin-left: 40px;
  list-style: disc;
  white-space: nowrap;
`;
